import Time from "../time";
import Crypto from "../crypto";
import Weather from "../weather";

export default function BottomBar({ topEspont, espont }) {
  return (
    <div className="bottom rounded-3xl">
      <div className="box">
        <div className="money">🔞 Do not gamble! Never chase your losses!</div>
        <div className="ma-kiosztva">
          <Time />
        </div>
        <div className="top">👑 {topEspont}</div>
        <Crypto espont={espont} />
        <Weather />
        <div className="insta flex items-center justify-center">
          {/* <img src="./instagram.svg" alt="ig" width="40px" /> @lebobopadre
          <img src="./instagram.svg" alt="ig" width="40px" /> @padrereward
          <img src="./instagram.svg" alt="ig" width="40px" /> @padrebonus */}
          <img src="./yt.svg" alt="yt" width="20px" className="mx-2" />
          <span className="ml-3">@padrebobo</span>
        </div>
      </div>
    </div>
  );
}
